import React from 'react';
import { motion } from 'framer-motion';
import { BatteryChargingIcon, ZapIcon } from 'lucide-react';
export function WhyLancer() {
  const hybridModels = ['Prius', 'Prius Prime', 'RAV4 Hybrid', 'RAV4 Prime', 'Camry Hybrid', 'Highlander Hybrid', 'Venza Hybrid', 'Sienna Hybrid'];
  return <section className="bg-white px-4 pt-0 pb-20" data-id="element-271">
      <div className="max-w-5xl mx-auto" data-id="element-272">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="relative bg-gray-950 text-white rounded-3xl overflow-hidden shadow-2xl shadow-black/20 border border-gray-800" data-id="element-273">
          {/* Subtle accent glow inside the panel */}
          <div className="absolute inset-0 opacity-30 pointer-events-none" style={{
          backgroundImage: 'radial-gradient(circle at 80% 20%, rgba(200,180,164,0.35), transparent 50%), radial-gradient(circle at 15% 95%, rgba(200,180,164,0.2), transparent 45%)'
        }} data-id="element-274" />

          {/* Cinematic banner image with headline overlay */}
          <div className="relative h-[280px] md:h-[380px] lg:h-[460px] overflow-hidden" data-id="element-275">
            <motion.img src="https://cdn.magicpatterns.com/uploads/jrtytHBJ3ViATfrLfvA91M/paul-esch-laurent-GN25mgCwbkc-unsplash.jpg" alt="Toyota GR Corolla driving on a snowy road" initial={{
            scale: 1.08
          }} whileInView={{
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.4,
            ease: 'easeOut'
          }} className="absolute inset-0 w-full h-full object-cover" data-id="element-276" />
            {/* Dark fade from image into the panel */}
            <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-gray-950/40 to-gray-950" data-id="element-277" />
            {/* Side vignettes */}
            <div className="absolute inset-y-0 left-0 w-1/4 bg-gradient-to-r from-gray-950/60 to-transparent" data-id="element-278" />
            <div className="absolute inset-y-0 right-0 w-1/4 bg-gradient-to-l from-gray-950/60 to-transparent" data-id="element-279" />

            {/* Headline overlay */}
            <div className="absolute inset-x-0 bottom-0 px-6 md:px-10 lg:px-14 pb-8 md:pb-10" data-id="element-280">
              <div className="text-center" data-id="element-281">
                <div className="inline-flex items-center gap-2 bg-brand-accent/20 border border-brand-accent/40 backdrop-blur-sm px-4 py-1.5 rounded-full mb-5" data-id="element-282">
                  <ZapIcon className="w-4 h-4 text-brand-accent" data-id="element-283" />
                  <span className="uppercase tracking-widest text-xs font-bold text-brand-accent" data-id="element-284">
                    Hybrid and EV service
                  </span>
                </div>
                <h2 className="font-heading uppercase tracking-wide text-3xl md:text-4xl lg:text-5xl font-extrabold leading-[1.05]" style={{
                textShadow: '0 2px 24px rgba(0,0,0,0.6)'
              }} data-id="element-285">
                  Gas, hybrids, and EVs — we handle them all.
                </h2>
              </div>
            </div>
          </div>

          <div className="relative px-6 md:px-10 lg:px-14 pt-4 pb-14 md:pb-16" data-id="element-286">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 items-stretch mt-6 md:mt-8" data-id="element-287">
              <div className="text-lg md:text-xl text-gray-300 leading-relaxed space-y-6 flex flex-col justify-center" data-id="element-288">
                <p data-id="element-289">
                  Toyota's hybrid system has been on the road for over two
                  decades. We've been servicing it just as long. Whether it's
                  routine maintenance, a warning light, electrical diagnostics,
                  or a hybrid system inspection — we know what we're looking at.
                </p>
                <p className="text-white font-bold" data-id="element-290">
                  Two decades of proven hybrid technology. Two decades of
                  hands-on experience servicing it.
                </p>
                <p data-id="element-291">
                  Prius battery service is one area where most independent shops
                  will refer you out. We handle it in-house — diagnostics,
                  maintenance, and repair. If your Prius has a battery concern,
                  or you just want to know where it stands, we can tell you
                  exactly what's going on.
                </p>
              </div>

              <div className="bg-gray-800/50 border border-gray-700 rounded-2xl p-6 md:p-8 shadow-xl shadow-black/30 flex flex-col" data-id="element-292">
                <p className="font-bold text-white text-xl mb-6" data-id="element-293">
                  We regularly service:
                </p>
                <ul className="grid grid-cols-2 gap-3 flex-grow content-start" data-id="element-294">
                  {hybridModels.map((item, index) => <li key={index} className="flex items-center gap-3 bg-gray-900/70 p-3 rounded-xl border border-gray-700" data-id="element-295">
                      <BatteryChargingIcon className="w-5 h-5 text-brand-accent flex-shrink-0" data-id="element-296" />
                      <span className="text-base text-gray-100 font-medium" data-id="element-297">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}